Namespace 'Monitoring.Reports.Competition'

class Monitoring.Reports.Competition.SocialAccountFilterView extends Backbone.View
  template: JST['backbone/templates/monitoring/reports/competition/social_account_filter']

  events:
    'click #select-all'    : '_selectAll'
    'click #clear-all'     : '_clearAll'
    'click .filter-toggle' : '_toggleFilter'


  initialize: (@options={}) ->
    @channels = @options.channels

  render: ->
    @$el.html(@template)
    @_renderDatepicker(@channels.length)
    @_renderTimezoneSelector()
    for channel in @channels
      sa = new Monitoring.Reports.Competition.SocialAccountView({channel: channel})
      sa.render()
      @$el.find('#social-accounts-selector-container').append(sa.el)


  _renderTimezoneSelector: ->
    @timezoneSelectorView = new Monitoring.Views.TimeZoneSelectorView()
    @$el.find('#timezone_selector').html(@timezoneSelectorView.render().el)

  _renderDatepicker:(channels) ->
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    @$el.find('.datepicker').datepicker({
      orientation: if channels > 3 then 'top' else 'bottom',
      todayBtn: 'linked',
      startDate: threeYearsAgo
    })
    @$el.find('#from_datepicker').datepicker('update', "<%= @from.strftime('%d-%b-%Y') %>");
    @$el.find('#to_datepicker').datepicker('update', "<%= @to.strftime('%d %b %Y') %>");

  _toggleFilter: ->
    @$el.find('#social-accounts-selector-container, #social-accounts-selector-options').slideToggle(300)

  _selectAll: ->
    @$el.find('input[type="checkbox"].social-account-checkbox').prop('checked', true)

  _clearAll: ->
    @$el.find('input[type="checkbox"].social-account-checkbox').prop('checked', false)